import { render, staticRenderFns } from "./SwitchCentro.vue?vue&type=template&id=9c41ce2a"
import script from "./SwitchCentro.vue?vue&type=script&lang=js"
export * from "./SwitchCentro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports